import { useMutation } from "@tanstack/react-query";
import { chatMessagesChain } from "../services/compass.service";
import type { IChatMessagesChainRequest } from "../types/compass.types";

export const useChatMessagesChain = () => {
  return useMutation({
    mutationFn: (data: IChatMessagesChainRequest) => chatMessagesChain(data),
  });
};
